import React, {useEffect, useState} from "react";
import BaseScreen from "../base/BaseScreen";
import {primaryBlack, HeaderLogo, inter, purple, purpleLight, SmallHeaderTitle, white, primaryPink} from "../../Theme";
import Api from "../../util/Api";
import styled from "styled-components";
import backLogoBlack from "../../resources/images/backBlack.svg";
import backLogoWhite from "../../resources/images/backWhite.svg";
import {ReactComponent as ChevronRight} from '../../resources/icons/chevron_right.svg';
import zoomLogo from "../../resources/images/zoom.svg";
import {darken} from 'polished';
import AppStorage, {StorageKey} from "../../util/AppStorage";
import showImagePopup from "../../popups/showImagePopup";
import {ContentWrapper, HeaderImage, HeaderImageWrapper} from "../more/MoreScreen";
import {device} from "../../constants/breakpoints";
import {useHistory, useParams} from "react-router-dom";
import {showNativeNavigation} from "../../AppInterface";
import {CheckItem} from "../../components/CheckItem";
import {FilterSelect} from "../../components/Select/FilterSelect";
import {PupilSchoolYearSelector} from "../../components/PupilSchoolYearSelector/PupilSchoolYearSelector";
import {useQuery} from "../../App";
import {PlanOfActionTabs} from "../../constants/enums";
import {ConfigurableLoader, Loader, LoaderOverlay} from "../../components/Loader";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import { usePageDataContext } from "../../contexts/PageDataContext";
import {getContextParams, getFilterParams} from "../../util/ParamsHelpers";

function ExecutiveFunctionScreen() {
    const history = useHistory();
    const [ef, setExecutiveFunction] = useState(history.location.state ? history.location.state.executiveFunction : null);
    const [efCheckedItems, setExecutiveFunctionCheckedItems] = useState([]);
    const [periodOptions, setPeriodOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isPeriodSwitchLoading, setIsPeriodSwitchLoading] = useState(true);
    const [requests, setRequests] = useState({
        checkItems: false,
        executiveFunction: false,
        period: false
    })
    const [periodQuestionnaireFilled, setPeriodQuestionnaireFilled] = useState(false);
    const params = useParams();
    const query = useQuery();
    const periodId = query.get("periodId");
    const {selectedSchoolYear, couldShowSchoolYearSelector, isSchoolYearContextReady} = usePageDataContext();

    useEffect(() => {
        if (!isSchoolYearContextReady) return;

        showNativeNavigation();
        getExecutiveFunction();
        getPeriod();
    // eslint-disable-next-line
    }, [params, selectedSchoolYear?.value, isSchoolYearContextReady]);

    useEffect(() => {
        if (Object.values(requests).every(r => r === true)) {
            setIsLoading(false)
        }
    }, [requests]);

    useEffect(() => {
        if (!isSchoolYearContextReady || !ef) return;

        getExecutiveFunctionCheckItems(periodId);
    // eslint-disable-next-line
    }, [ef, selectedSchoolYear?.value, periodId, isSchoolYearContextReady]);

    if (isLoading || !isSchoolYearContextReady) {
        return <Loader/>
    }

    const breakpoint = "1024px";

    const content = (
        <EFScreen backgroundColor={ef ? ef.color : purpleLight}>

            <StyledPageHeader $backgroundColor={ef ? darken(0.05, ef.color) : purple} breakpoint={breakpoint}>
                <PageHeader.Start breakpoint={breakpoint}>
                    <StyledHeaderLogo src={ef ? (ef.hasDarkText ? backLogoBlack : backLogoWhite) : backLogoWhite} onClick={() => {
                        const activeTab = history.location.state.activeTab;
                        if (activeTab !== undefined) {
                            history.push(`/ef-voortgang/${periodId}${activeTab}`)
                        } else {
                            history.goBack()
                        }
                    }}/>
                </PageHeader.Start>
                <PageHeader.Center breakpoint={breakpoint}>
                    <StyledSmallHeaderTitle color={ef ? (ef.hasDarkText ? primaryBlack : white) : white}>Executieve Functies</StyledSmallHeaderTitle>
                </PageHeader.Center>
                <PageHeader.End breakpoint={breakpoint}>
                    <DropdownWrapper $couldShowSchoolYearSelector={couldShowSchoolYearSelector}>
                        <PupilSchoolYearSelector />
                        {periodOptions?.length > 0 &&
                            <PeriodDropdown options={periodOptions} isDisabled={isLoading} navigateToPeriod={(newPeriodId) => {
                                setIsPeriodSwitchLoading(true)
                                history.replace("/executieve-functies/" + ef.id + `?periodId=${newPeriodId}`, {activeTab: history.location.state.activeTab})
                            }}/>
                        }
                    </DropdownWrapper>
                </PageHeader.End>
            </StyledPageHeader>

            <ContentWrapper>
                <HeaderImageWrapper>
                    <HeaderImage src={ef ? ef.imageUrl : undefined}/>
                    <ZoomImage src={zoomLogo} onClick={() => showImagePopup(ef.imageUrl)}/>
                </HeaderImageWrapper>
                {ef && <EFCardWrapper>
                    <EFCard>
                        { isPeriodSwitchLoading  &&
                            <LoaderOverlay>
                                <StyledLoader delay={false}/>
                            </LoaderOverlay>
                        }

                        <CardHeader>
                            <TitleHeader>
                                <Icon backgroundColor={ef ? ef.color : purple}
                                      color={ef ? (ef.hasDarkText ? primaryBlack : white) : white}>{ef ? ef.sortOrder + 1 : ''}</Icon>
                                <Title>{ef ? ef.title : 'Executieve Functie'}</Title>
                            </TitleHeader>
                            {periodQuestionnaireFilled === true &&
                                <BackTo onClick={() => {
                                    history.push(`/ef-voortgang/${periodId}?activeTab=${PlanOfActionTabs.PLANOFACTION}`)
                                }}>
                                    Naar Plan van Aanpak <StyledChevronRight/>
                                </BackTo>
                            }
                        </CardHeader>
                        <Subtitle>{ef && ef.subtitle}</Subtitle>
                        <CheckLists>
                            {ef && ef.checkLists.map((checkList) => {
                                return (
                                    <CheckList key={checkList.id}>
                                        <CheckListTitle>{checkList.title}</CheckListTitle>
                                        {checkList.checkItems.map((checkItem) => {
                                            const isChecked = !!efCheckedItems.find((item) => {
                                                return item.id === checkItem.id
                                            })
                                            return <CheckItem key={checkItem.id} checkItem={checkItem} isChecked={isChecked} updateCheckedItems={getExecutiveFunctionCheckItems} executiveFunction={ef} periodId={periodId}/>
                                        })}
                                    </CheckList>
                                )
                            })}
                        </CheckLists>
                    </EFCard>
                </EFCardWrapper>}
            </ContentWrapper>
        </EFScreen>
    );

    return (
        <BaseScreen
            activeMenuItem={"Executieve Functies"}
            content={content}
        />
    )

    function getExecutiveFunctionCheckItems(periodId) {
        if (periodId === null) periodId = periodOptions[0].value

        const config = {
            params: {
                ...getFilterParams({
                    'filter[executiveFunctionId]': decodeURIComponent(params.id).trim(),
                    'filter[periodId]': periodId,
                })
            }
        };

        Api.get('pupils/' + AppStorage.get(StorageKey.PUPIL_ID) + "/checkItems", (response) => {
            setExecutiveFunctionCheckedItems(response.data)
            setRequests(prevRequests => ({
                ...prevRequests,
                checkItems: true,
            }));
        }, null, onFailure, onFailure, config);

        function onFailure() {
            setIsLoading(false)
        }
    }

    function getExecutiveFunction() {
        Api.get(`executiveFunctions/${decodeURIComponent(params.id).trim()}`, (response) => {
            setExecutiveFunction(response.data)
            setPeriodOptions(response.data.periodFilterOptions)
            setRequests(prevRequests => ({
                ...prevRequests,
                executiveFunction: true
            }));
        }, null, onFailure, onFailure);

        function onFailure() {
            setIsLoading(false)
        }
    }

    function getPeriod() {
        const params = getContextParams();
        if (!params) return;

        const config = {
            params: {
                ...params,
            }
        }

        // Need to get period to check if questionnaire is filled
        Api.get(`periods/${periodId}`, (response) => {
            setPeriodQuestionnaireFilled(response.data.scoresPerExecutiveFunction.filter(ef => ef.totalScore == null).length === 0)
            setRequests(prevRequests => ({
                ...prevRequests,
                period: true
            }));
            setIsPeriodSwitchLoading(false)
        }, null, onFailure, onFailure, config);

        function onFailure() {
            setIsLoading(false)
        }
    }
}

function PeriodDropdown({options, isDisabled, navigateToPeriod}) {
    const query = useQuery();
    const periodId = query.get("periodId")

    return (
        <FilterSelectWrapper>
            <FilterSelect
                defaultValue={options.find(x => x.value === periodId)}
                options={options}
                disabled={isDisabled}
                onChange={(selectedOption) => {
                    navigateToPeriod(selectedOption.value)
                }}
            />
        </FilterSelectWrapper>
    )
}

export const ZoomImage = styled.img`
    src: ${props => props.src};
    cursor: pointer;
    width: 35px;
    height: 35px;
    padding: 8px;
    background: rgba(0, 0, 0, 0.4);
    box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.6);
    border-radius: 3px;
    position: absolute;
    top: 55px;
    right: 15px;
    z-index: 10;

    @media screen and ${device.mobileL} {
        top: 15px;
    }
`;

const StyledLoader = styled(ConfigurableLoader)`
    top: 150px;
    transform: translateX(-50%);
    z-index: 1;
`;

export const CheckLists = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding-top: 30px;
`;

const CheckListTitle = styled.div`
    font-family: ${inter};
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
`;

const EFCardWrapper = styled.div`
    max-width: 679px;
    margin: auto;
    padding: 0 20px;
    box-sizing: content-box;
`;

const EFCard = styled.div`
    width: 100%;
    background: ${white};
    padding: 35px 40px;
    z-index: 10;
    position: relative;
    top: -110px;
    border-radius: 3px;

    @media screen and ${device.mobileL} {
        top: -40px;
        padding: 15px 20px;
    }
`;

const CheckList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const Subtitle = styled.div`
    font-family: ${inter};
    opacity: 0.7;
    font-style: italic;
    font-weight: normal;
    font-size: 14px;
    margin-top: 17px;
`;

const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
`;

const TitleHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 18px;
`;

const Icon = styled.div`
    color: ${props => props.color};
    background-color: ${props => props.backgroundColor};
    min-width: 32px;
    min-height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
`;

const Title = styled.div`
    font-family: ${inter};
    color: black;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 38px;
`

const StyledPageHeader = styled(PageHeader)`
    background-color: ${({$backgroundColor}) => $backgroundColor};
`;

const DropdownWrapper = styled.div`
    display: grid;
    grid-template-columns: ${({$couldShowSchoolYearSelector}) => $couldShowSchoolYearSelector ? "repeat(2, 1fr)" : "1fr"};
    gap: 6px;
    align-items: center;
`;

const StyledHeaderLogo = styled(HeaderLogo)`
    vertical-align: middle;
`;

const StyledSmallHeaderTitle = styled(SmallHeaderTitle)`
    text-wrap: nowrap;
    
    @media screen and ${device.tablet} {
        margin: 0 32px;
    }
`;

const FilterSelectWrapper = styled.div`
    padding: 10px 0;
    right: 40px;
    flex-shrink: 1;
    
    @media screen and (max-width: 1024px) {
        padding: 0;
    }
`;

const EFScreen = styled.div`
    width: 100%;
    position: relative;
    background: ${props => props.backgroundColor};
`;

const BackTo = styled.button`
    display: flex;
    gap: 6px;
    color: ${primaryPink};
    border: none;
    font-family: ${inter};
    font-weight: 700;
    font-size: 16px;
    background: none;
    justify-content: center;
    align-items: center;
    padding: 6px 0;

    &:hover {
        cursor: pointer;
    }
`;

const StyledChevronRight = styled(ChevronRight)`
    width: 14px;
    height: 14px;
    color: ${primaryPink};
`;

export default ExecutiveFunctionScreen;
